import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { logoutUser } from '../../actions/authenticateActions';
import { searchInvoice, clearSearchInvoice } from '../../actions/invoiceDateActions.js';
import { findDOMNode } from 'react-dom';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeDropdown: null,
            isSearchOpen: false,
            isMobileMenuOpen: false,
            searchValue: ''
        };
        this.node = React.createRef();
        this.searchInputRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick, false);
    }

    handleOutsideClick = (event) => {
        const node = findDOMNode(this.node.current);
        if (node && node.contains(event.target)) {
            return;
        }
        this.setState({ activeDropdown: null });
    }

    handleLogout = () => {
        const { dispatch } = this.props;
        dispatch(logoutUser(
            () => {
                localStorage.clear();
                this.props.history.push('/login');
            },
            () => {
                localStorage.clear();
                this.props.history.push('/login');
            }
        ));
    }

    handleSearch = (event) => {
        if (event.key === 'Enter' && this.state.searchValue.trim()) {
            const { dispatch } = this.props;
            dispatch(searchInvoice(this.state.searchValue.trim()));
            this.props.history.push('/home');
            this.setState({ isSearchOpen: false });
        }
    }

    handleSearchChange = (event) => {
        this.setState({ searchValue: event.target.value });
    }

    clearSearch = () => {
        const { dispatch } = this.props;
        this.setState({ searchValue: '' });
        if (this.searchInputRef.current) {
            this.searchInputRef.current.focus();
        }
        dispatch(clearSearchInvoice());
    }

    toggleDropdown = (dropdown) => {
        this.setState(prevState => ({
            activeDropdown: prevState.activeDropdown === dropdown ? null : dropdown
        }));
    }

    toggleSidebar = () => {
        document.body.classList.toggle('aside-toggled');
    }

    toggleSearch = () => {
        this.setState(prevState => ({ 
            isSearchOpen: !prevState.isSearchOpen 
        }), () => {
            if (this.state.isSearchOpen && this.searchInputRef.current) {
                this.searchInputRef.current.focus();
            }
        });
    }

    toggleMobileMenu = () => {
        this.setState(prevState => ({ 
            isMobileMenuOpen: !prevState.isMobileMenuOpen 
        }));
    }

    render() {
        const { activeDropdown, isSearchOpen, isMobileMenuOpen, searchValue } = this.state;

        return (
            <div className="relative">
                <nav className="fixed top-0 left-0 right-0 bg-white shadow-lg z-50">
                    <div className="max-w-full mx-auto">
                        <div className="flex justify-between items-center px-6 h-32">
                            {/* Logo Section */}
                            <div className="flex-shrink-0 flex items-center">
                                <button className="flex items-center">
                                    <img
                                        src={require('../../assets/img/logo-2-white.png')}
                                        className="h-28 w-72 object-contain transform transition-transform duration-200 hover:scale-105"
                                        alt="Logo"
                                    />
                                </button>
                            </div>

                            {/* Main Navigation */}
                            <div className="flex items-center space-x-8">
                                {/* Toggle & Search */}
                                <button
                                    onClick={this.toggleSidebar}
                                    className="group p-4 rounded-lg bg-transparent hover:bg-gray-100 transition-colors duration-200"
                                    aria-label="Toggle sidebar"
                                >
                                    <i className="fa fa-align-left text-3xl text-gray-600 group-hover:text-gray-900"></i>
                                </button>
                                <button
                                    onClick={this.toggleSearch}
                                    className="group p-4 rounded-lg bg-transparent hover:bg-gray-100 transition-colors duration-200"
                                    aria-label="Toggle search"
                                >
                                    <i className="fa fa-search text-3xl text-gray-600 group-hover:text-gray-900"></i>
                                </button>

                                {/* User Dropdown */}
                                <div className="relative" ref={this.node}>
                                    <button
                                        onClick={() => this.toggleDropdown('userDropdown')}
                                        className="group p-4 rounded-lg bg-transparent hover:bg-gray-100 transition-colors duration-200"
                                        aria-label="User menu"
                                    >
                                        <i className="fa fa-user text-3xl text-gray-600 group-hover:text-gray-900"></i>
                                    </button>

                                    <div className={`absolute right-0 mt-2 w-48 rounded-lg shadow-lg transform transition-all duration-200 origin-top-right 
                                        ${activeDropdown === 'userDropdown' ? 'scale-100 opacity-100' : 'scale-95 opacity-0 pointer-events-none'}`}>
                                        <div className="bg-white rounded-lg ring-1 ring-black ring-opacity-5">
                                            <button
                                                onClick={this.handleLogout}
                                                className="flex w-full items-center px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors duration-200"
                                            >
                                                <i className="fa fa-sign-out w-8 text-xl"></i>
                                                <span>Logout</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Mobile Menu Button */}
                            <button
                                onClick={this.toggleMobileMenu}
                                className="lg:hidden p-3 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors duration-200"
                                aria-label="Toggle mobile menu"
                            >
                                <i className={`fa ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-2xl`}></i>
                            </button>
                        </div>

                        {/* Mobile Menu */}
                        <div className={`lg:hidden transition-all duration-300 ease-in-out ${
                            isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 pointer-events-none'
                        }`}>
                            <div className="px-4 py-3 space-y-2 border-t border-gray-100">
                                <button
                                    onClick={this.toggleSidebar}
                                    className="flex w-full items-center p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                                >
                                    <i className="fa fa-align-left w-8 text-xl text-gray-600"></i>
                                    <span className="text-gray-700">Toggle Sidebar</span>
                                </button>
                                <button
                                    onClick={this.toggleSearch}
                                    className="flex w-full items-center p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                                >
                                    <i className="fa fa-search w-8 text-xl text-gray-600"></i>
                                    <span className="text-gray-700">Search</span>
                                </button>
                                <div className="h-px bg-gray-100 my-2"></div>
                                <button
                                    onClick={this.handleLogout}
                                    className="flex w-full items-center p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                                >
                                    <i className="fa fa-sign-out w-8 text-xl text-gray-600"></i>
                                    <span className="text-gray-700">Logout</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Search Panel */}
                    <div className={`absolute left-0 right-0 top-full transform transition-all duration-300 ease-in-out
                        ${isSearchOpen ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0 pointer-events-none'}`}>
                        <div className="bg-white shadow-lg">
                            <div className="container mx-auto px-4 py-4">
                                <div className="relative max-w-3xl mx-auto">
                                    <i className="fa fa-search absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                                    <input
                                        ref={this.searchInputRef}
                                        type="text"
                                        value={searchValue}
                                        onChange={this.handleSearchChange}
                                        placeholder="Type and hit Enter to search..."
                                        className="w-full px-4 py-3 pl-12 pr-10 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        onKeyPress={this.handleSearch}
                                    />
                                    {searchValue && (
                                        <button
                                            onClick={this.clearSearch}
                                            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
                                            aria-label="Clear search"
                                        >
                                            <i className="fa fa-times"></i>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>

                {/* Mobile Menu Overlay */}
                {isMobileMenuOpen && (
                    <div 
                        className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
                        onClick={this.toggleMobileMenu}
                    ></div>
                )}

                {/* Additional padding to prevent content from hiding under fixed header */}
                <div className="h-32"></div>
            </div>
        );
    }
}

const mapStateToProps = () => ({});

export default withRouter(connect(mapStateToProps)(Header));